import z from "zod";

export const getCrewDefinitionTicketAssignmentParamSchema = z.object({
	crewDefinitionId: z.uuid(),
	ticketAssignmentId: z.uuid(),
});

export type GetCrewDefinitionTicketAssignmentParamSchema = z.infer<
	typeof getCrewDefinitionTicketAssignmentParamSchema
>;
